import { MathUtils } from "source/app/services/Math/MathUtils";

export const GetWeightNumber = (weightString: string) => {
    if (!MathUtils.IsValidNumber(weightString)) {
        return undefined;
    }

    const parsedFloat = Number.parseFloat(weightString);
    const withDecimal = parsedFloat.toFixed(1);
    const result = Number.parseFloat(withDecimal);
    return result;
};
